import { techDataColsAPINames as k, techDataSections as s } from "./TechnicalDataEnums";

export const techDataParentColumnSpecType = {
  BOOL_DROPDOWN: "boolDropdown",
  DROPDOWN: "dropdown",
  ROUNDED: "rounded",
  TYPICAL: "typical",
  TYPICAL_FALSE: "typicalFalse",
  WALL_AREA: "wallArea",
  WALL_DESCRIPTION: "wallDescription",
  WALL_FILES: "wallFiles",
  WALL_THICKNESS: "wallThickness",
  WALL_U_VALUE: "wallUValue",
  WIN_AREA: "winArea",
  WIN_G_VALUE: "winGValue",
  WIN_LAST_CHECKED: "winLastChecked",
  WIN_NUM_WINDOWS: "winNumWindows",
  WIN_U_VALUE: "winUValue",
  WIN_WINDOW_TYPE: "winWindowType",
};

export const techDataDropdownKind = {
  HEATING_COOLING_ENERGY: "heatingCoolingEnergy",
  HEATING_COOLING_SYSTEM: "heatingCoolingSystem",
  HOT_WATER_DECENTRAL_TYPE: "hotWaterDecentralType",
  HOT_WATER_ENERGY: "hotWaterEnergy",
  HOT_WATER_SYSTEM: "hotWaterSystem",
  LINKED_HEATING_SYSTEM: "linkedHeatingSystem",
};

const heatingCoolingSpecs = [
  { dataKey: k.DESCRIPTION, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
  { dataKey: k.AREA_COVERED, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
  {
    dataKey: k.SYSTEM_TYPE,
    dropdownKind: techDataDropdownKind.HEATING_COOLING_SYSTEM,
    isInDefault: true,
    type: techDataParentColumnSpecType.DROPDOWN,
  },
  {
    dataKey: k.ENERGY_SOURCE,
    dropdownKind: techDataDropdownKind.HEATING_COOLING_ENERGY,
    isInDefault: true,
    type: techDataParentColumnSpecType.DROPDOWN,
  },
  { dataKey: k.PEAK_THERMAL_POWER, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
  { dataKey: k.STORAGE_VOLUME, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
  { dataKey: k.STORAGE_TEMPERATURE, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
  { dataKey: k.MONITORING_INSTALLED, isInDefault: true, type: techDataParentColumnSpecType.BOOL_DROPDOWN },
  { dataKey: k.COP, isInDefault: true, type: techDataParentColumnSpecType.ROUNDED },
  { dataKey: k.SYSTEM_NAME, isInDefault: false, type: techDataParentColumnSpecType.TYPICAL_FALSE },
  { dataKey: k.MANUFACTURER_NAME, isInDefault: false, type: techDataParentColumnSpecType.TYPICAL_FALSE },
  { dataKey: k.INSTALLED, isInDefault: false, type: techDataParentColumnSpecType.TYPICAL_FALSE },
  { dataKey: k.STORAGE_LOSSES, isInDefault: false, type: techDataParentColumnSpecType.TYPICAL_FALSE },
  { dataKey: k.DISTRIBUTION_LOSSES, isInDefault: false, type: techDataParentColumnSpecType.TYPICAL_FALSE },
];

const wallAndRooftopSpecs = [
  { dataKey: k.DESCRIPTION, isInDefault: true, type: techDataParentColumnSpecType.WALL_DESCRIPTION },
  { dataKey: k.AREA, isInDefault: true, type: techDataParentColumnSpecType.WALL_AREA },
  { dataKey: k.LAST_CHECKED, isInDefault: false, type: techDataParentColumnSpecType.TYPICAL_FALSE },
  { dataKey: k.COLOR, isInDefault: false, type: techDataParentColumnSpecType.TYPICAL_FALSE },
  { dataKey: k.MODERNIZATION, isInDefault: false, type: techDataParentColumnSpecType.TYPICAL_FALSE },
  { dataKey: k.INSTALLED, isInDefault: false, type: techDataParentColumnSpecType.TYPICAL_FALSE },
  { dataKey: k.U_VALUE, isInDefault: true, type: techDataParentColumnSpecType.WALL_U_VALUE },
  { dataKey: k.THICKNESS, isInDefault: true, type: techDataParentColumnSpecType.WALL_THICKNESS },
  { dataKey: "files", isInDefault: true, type: techDataParentColumnSpecType.WALL_FILES },
];

const windowsSpecs = [
  { dataKey: k.WINDOW_TYPE, isInDefault: true, type: techDataParentColumnSpecType.WIN_WINDOW_TYPE },
  { dataKey: k.NUMBER_OF_WINDOWS, isInDefault: true, type: techDataParentColumnSpecType.WIN_NUM_WINDOWS },
  { dataKey: k.AREA, isInDefault: true, type: techDataParentColumnSpecType.WIN_AREA },
  { dataKey: k.U_VALUE, isInDefault: true, type: techDataParentColumnSpecType.WIN_U_VALUE },
  { dataKey: k.G_VALUE, isInDefault: true, type: techDataParentColumnSpecType.WIN_G_VALUE },
  { dataKey: k.LAST_CHECKED, isInDefault: true, type: techDataParentColumnSpecType.WIN_LAST_CHECKED },
];

export const techDataParentTabColumnSpecs = {
  [s.COOLING_SYSTEM]: heatingCoolingSpecs,
  [s.ENERGY_MIX]: [
    { dataKey: k.UTILITY_MIX, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
    { dataKey: k.COST_PER_KWH, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
    { dataKey: k.COST_INCREASE_PER_YEAR, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
    { dataKey: k.CO2_EMISSIONS_PER_KWH, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
  ],
  [s.HEATING_SYSTEM]: heatingCoolingSpecs,
  [s.HOT_WATER]: [
    { dataKey: k.DESCRIPTION, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
    // {
    //   dataKey: k.HEATING_SYSTEM,
    //   dropdownKind: techDataDropdownKind.LINKED_HEATING_SYSTEM,
    //   isInDefault: true,
    //   type: techDataParentColumnSpecType.DROPDOWN,
    // },
    { dataKey: k.AREA_COVERED, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
    {
      dataKey: k.SYSTEM_TYPE,
      dropdownKind: techDataDropdownKind.HOT_WATER_SYSTEM,
      isInDefault: true,
      type: techDataParentColumnSpecType.DROPDOWN,
    },
    // {
    //   dataKey: k.DECENTRAL_TYPE,
    //   dropdownKind: techDataDropdownKind.HOT_WATER_DECENTRAL_TYPE,
    //   isInDefault: true,
    //   type: techDataParentColumnSpecType.DROPDOWN,
    // },
    {
      dataKey: k.ENERGY_SOURCE,
      dropdownKind: techDataDropdownKind.HOT_WATER_ENERGY,
      isInDefault: true,
      type: techDataParentColumnSpecType.DROPDOWN,
    },
    { dataKey: k.STORAGE_VOLUME, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
    { dataKey: k.STORAGE_TEMPERATURE, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
    { dataKey: k.STORAGE_LOSSES, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
    { dataKey: k.INSTALLED, isInDefault: false, type: techDataParentColumnSpecType.TYPICAL_FALSE },
    { dataKey: k.DISTRIBUTION_LOSSES, isInDefault: false, type: techDataParentColumnSpecType.TYPICAL_FALSE },
  ],
  [s.INFILTRATION]: [
    { dataKey: k.DESCRIPTION, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
    { dataKey: k.AREA_COVERED, isInDefault: true, type: techDataParentColumnSpecType.ROUNDED },
    { dataKey: k.INFILTRATION, isInDefault: true, type: techDataParentColumnSpecType.ROUNDED },
  ],
  [s.PV_SYSTEM]: [
    { dataKey: k.CAPACITY_PANEL, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
    { dataKey: k.DC_AC_INVERTER_CONFIGURATION, isInDefault: true, type: techDataParentColumnSpecType.TYPICAL },
  ],
  [s.ROOFTOP]: wallAndRooftopSpecs,
  [s.WALL]: wallAndRooftopSpecs,
  [s.WINDOWS]: windowsSpecs,
};

const parentTabKeysForInitialState = Object.keys(techDataParentTabColumnSpecs);

export const defaultTechDataParentTabColNames = parentTabKeysForInitialState.reduce((acc, sectionKey) => {
  acc[sectionKey] = techDataParentTabColumnSpecs[sectionKey].filter((c) => c.isInDefault).map((c) => c.dataKey);
  return acc;
}, {});
